import Vue from 'vue';
import Vuex from 'vuex';

// 简化版Store - 仅保留必要功能
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 空状态，使用localStorage存储token
  },
  getters: {
    isAuthenticated() {
      return !!localStorage.getItem('token');
    }
  }
});